import { render, staticRenderFns } from "./EnrollmentTool.vue?vue&type=template&id=04b7ff4f&scoped=true"
import script from "./EnrollmentTool.vue?vue&type=script&lang=js"
export * from "./EnrollmentTool.vue?vue&type=script&lang=js"
import style0 from "./EnrollmentTool.vue?vue&type=style&index=0&id=04b7ff4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b7ff4f",
  null
  
)

export default component.exports